export default {
  任务中心: "任務中心",
  消息提醒: "消息提醒",
  "拜访&审计日程": "拜訪&審計日程",
  VCR任务: "VCR任務",
  供应商资质到期预警: "供應商資質到期預警",
  合同到期预警: "合同到期預警",
  "近6个月采购订单数量/金额趋势": "近6個月採購訂單數量/金額趨勢",
  剩余: "剩餘",
  天: "天",
  序号: "序號",
  任务标题: "任務標題",
  任务状态: "任務狀態",
  全部: "全部",
  待办: "待辦",
  已办: "已辦",
  单据类型: "單據類型",
  发起人: "發起人",
  发起部门: "發起部門",
  接收时间: "接收時間",
  进行中: "進行中",
  生产物料: "生產物料",
  非生产物料: "非生產物料",
  快捷应用: "快捷應用",
  代供应商注册: "代供應商註冊",
  发起供应商评估: "發起供應商評估",
  创建准入申请: "創建准入申請",
  创建价格申请: "創建價格申請",
  发起询价: "發起詢價",
  建立合同: "建立合同",
  查看更多: "查看更多",
  未处理: "未處理",
  已询价: "已詢價",
  已转PO: "已轉PO",
  已到货: "已收貨",
  已付款: "已付款",
  待开始: "待開始",
  物料质量标准已确定: "物料質量標準已確定",
  供应商开发与筛选已完成: "供應商開發與篩選已完成",
  供应商选择与评估已完成: "供應商選擇與評估已完成",
  样品小试或中试研究已完成: "樣品小試或中試研究已完成",
  "供应商合格认证已完成（原供应商准入）":
    "供應商合格認證已完成（原供應商准入）",
  采购任务: "採購任務",
  寻源任务: "尋源任務",
  我收到的: "我收到的",
  我发起的: "我發起的",
  供应商名称: "供應商名稱",
  发起时间: "發起時間",
  流程用时: "流程用時",
  小时: "小時",
  分钟: "分鐘",
  已结束: "已結束",
  未读: "未讀",
  已读: "已讀",
  消息提醒列表: "消息提醒列表",
  消息状态: "消息狀態",
};
